import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';


import { EventReservationModalComponent } from 'extensions/st/piece-events/front/event-reservation-modal/event-reservation-modal.component';
import { DurationPipe } from 'extensions/st/piece-events/front/pipes/duration.pipe';
import { SafeDatePipe } from 'extensions/st/piece-events/front/pipes/safe-date.pipe';
import { ApiEventsService } from 'extensions/st/piece-events/front/services/api-events.service';

import { PieceEventsRenderComponent } from './piece-events-render.component';


export const pieceEventsRenderModuleEntryComponents = [
  PieceEventsRenderComponent,
  EventReservationModalComponent
];

@NgModule({
  imports: [
    ReactiveFormsModule,
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    DurationPipe,
    SafeDatePipe
  ],
  providers: [
    ApiEventsService
  ],
  declarations: [
    PieceEventsRenderComponent,
    EventReservationModalComponent,
  ]
})
export class PieceEventsRenderModule {}

export default pieceEventsRenderModuleEntryComponents;
